import { BellIcon } from '@heroicons/react/24/outline';
import { useNavigate } from 'react-location';
import { wrapClick } from 'utils';
import { useSupplierInboxOptional } from './InboxProvider';

const InboxBadge = () => {
  const navigate = useNavigate();
  const inbox = useSupplierInboxOptional();
  if (!inbox) return null;

  const unattended = inbox.count;
  const label = unattended > 0 ? `Inbox, ${unattended} unattended` : 'Inbox';

  return (
    <button
      type="button"
      onClick={wrapClick(() =>
        navigate({
          to: '/inbox',
          search: (prev) => ({ ...prev }),
        }),
      )}
      className="relative inline-flex items-center justify-center rounded-full border border-gray-200 bg-white p-2 text-gray-600 shadow-sm transition hover:border-primary-300 hover:text-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
      title={label}
      aria-label={label}
    >
      <BellIcon className="h-5 w-5" aria-hidden="true" />
      {unattended > 0 ? (
        <span className="absolute -top-1.5 -right-1.5 flex h-5 min-w-[1.25rem] items-center justify-center rounded-full bg-red-500 px-1 text-[10px] font-bold text-white ring-2 ring-white">
          {unattended > 99 ? '99+' : unattended}
        </span>
      ) : null}
    </button>
  );
};

export default InboxBadge;
